/**
 * Email de Boas-Vindas
 * Template enviado após a conclusão bem-sucedida do cadastro do premiado.
 */

import { montarBase } from './EmailBase';

export interface EmailBoasVindasParams {
  nome: string;
  email: string;
  documento: string;
}

export function gerarEmailBoasVindas(params: EmailBoasVindasParams): string {
  const primeiroNome = params.nome.split(' ')[0];

  const conteudo = `
    <p style="margin: 0 0 16px 0; font-size: 15px; color: #475569; line-height: 1.7;">
      Seu cadastro na plataforma <strong style="color: #F97316;">GetPoints</strong> foi realizado com sucesso!
      Agora você faz parte de uma comunidade que transforma desempenho em recompensas reais.
    </p>

    <!-- Card de Resumo da Conta -->
    <table width="100%" cellpadding="0" cellspacing="0" style="margin: 24px 0; background-color: #FFF7ED; border: 1px solid #FED7AA; border-radius: 10px;">
      <tr>
        <td style="padding: 20px 24px;">
          <p style="margin: 0 0 14px 0; font-size: 14px; font-weight: 700; color: #9A3412; text-transform: uppercase; letter-spacing: 1px;">Resumo da Conta</p>
          <table width="100%" cellpadding="0" cellspacing="0">
            <tr>
              <td style="padding: 8px 0; border-bottom: 1px solid #FED7AA;">
                <span style="font-size: 13px; color: #92400E; font-weight: 600;">Nome</span>
              </td>
              <td align="right" style="padding: 8px 0; border-bottom: 1px solid #FED7AA;">
                <span style="font-size: 13px; color: #431407;">${params.nome}</span>
              </td>
            </tr>
            <tr>
              <td style="padding: 8px 0; border-bottom: 1px solid #FED7AA;">
                <span style="font-size: 13px; color: #92400E; font-weight: 600;">Documento</span>
              </td>
              <td align="right" style="padding: 8px 0; border-bottom: 1px solid #FED7AA;">
                <span style="font-size: 13px; color: #431407;">${params.documento}</span>
              </td>
            </tr>
            <tr>
              <td style="padding: 8px 0;">
                <span style="font-size: 13px; color: #92400E; font-weight: 600;">E-mail</span>
              </td>
              <td align="right" style="padding: 8px 0;">
                <span style="font-size: 13px; color: #431407;">${params.email}</span>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

    <!-- CTA - Acessar Conta -->
    <table width="100%" cellpadding="0" cellspacing="0" style="margin: 28px 0;">
      <tr>
        <td align="center">
          <a href="https://getpoints.com.br/premiado/login" style="display: inline-block; background: linear-gradient(135deg, #F97316, #EA580C); color: #FFFFFF; font-size: 15px; font-weight: 700; text-decoration: none; padding: 14px 40px; border-radius: 8px; border: none;">
            Acessar Minha Conta
          </a>
        </td>
      </tr>
    </table>

    <!-- Próximos Passos -->
    <p style="margin: 28px 0 16px 0; font-size: 14px; font-weight: 700; color: #1E293B;">Próximos Passos:</p>

    <table width="100%" cellpadding="0" cellspacing="0" style="margin-bottom: 8px;">
      <tr>
        <td style="vertical-align: top; width: 32px; padding-top: 2px;">
          <span style="display: inline-block; width: 24px; height: 24px; background-color: #DCFCE7; border-radius: 50%; text-align: center; line-height: 24px; font-size: 12px; color: #16A34A; font-weight: 700;">1</span>
        </td>
        <td style="font-size: 14px; color: #475569; line-height: 1.6; padding-bottom: 12px;">
          <strong style="color: #334155;">Complete seu perfil</strong> e ganhe pontos extras de boas-vindas.
        </td>
      </tr>
      <tr>
        <td style="vertical-align: top; width: 32px; padding-top: 2px;">
          <span style="display: inline-block; width: 24px; height: 24px; background-color: #FEF3C7; border-radius: 50%; text-align: center; line-height: 24px; font-size: 12px; color: #D97706; font-weight: 700;">2</span>
        </td>
        <td style="font-size: 14px; color: #475569; line-height: 1.6; padding-bottom: 12px;">
          <strong style="color: #334155;">Explore as campanhas disponíveis</strong> e comece a participar.
        </td>
      </tr>
      <tr>
        <td style="vertical-align: top; width: 32px; padding-top: 2px;">
          <span style="display: inline-block; width: 24px; height: 24px; background-color: #FFEDD5; border-radius: 50%; text-align: center; line-height: 24px; font-size: 12px; color: #EA580C; font-weight: 700;">3</span>
        </td>
        <td style="font-size: 14px; color: #475569; line-height: 1.6;">
          <strong style="color: #334155;">Acumule pontos e troque por recompensas</strong> exclusivas.
        </td>
      </tr>
    </table>
  `;

  return montarBase({
    titulo: `Bem-vindo, ${primeiroNome}!`,
    saudacao: `Olá, <strong style="color: #1E293B;">${params.nome}</strong>! É um prazer ter você conosco.`,
    conteudo,
  });
}